import { misc } from "app/themes/colors";

export const CHART_NOTES_STYLE_TAB_LIST_SX = {
  background: misc.lightMutedPurple,
  "& button": { background: "white" },
  "& button:first-of-type": { borderTopLeftRadius: "6px" },
  "& button:last-of-type": { borderTopRightRadius: "6px" },
  "& .tabText": {
    color: misc.sunoGreen,
    borderBottom: `dotted 2px ${misc.highlightPurple}`
  },
  "& .Mui-selected": {
    fontWeight: 400,
    background: misc.lightLavender,
    border: `solid 1px ${misc.subMenuItem}`
  },
  "& .MuiTabs-indicator": { height: "4px" }
} as const;

export const CHART_NOTES_STYLE_TAB_LIST_SCROLL_SX = {
  "& .MuiTabs-flexContainer": {
    overflowX: "auto",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none"
    },
    WebkitOverflowScrolling: { xs: "touch", md: "auto" }
  }
} as const;
